import { render } from "./UserSearchCriteria.vue?vue&type=template&id=0afef2cb"
import script from "./UserSearchCriteria.vue?vue&type=script&lang=js"
export * from "./UserSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__